import React, { useState, useEffect } from "react";
import { faArrowRightArrowLeft, faChevronDown, faChevronLeft, faChevronRight, faClockRotateLeft, faMagnifyingGlass, faXmark, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSwipeable } from "react-swipeable";
import { SERVER_URL, AVALANCHE_RPC } from "../../../Config";
import axios from "axios";
import { ethers } from "ethers";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { token_abi, usdccontractaddress, usdtcontractaddress } from "../../../abi";
import { ClipLoader } from "react-spinners";

const Send = () => {

  const [isSwipedRight, setIsSwipedRight] = useState(false);
  const [UserAccounts, setUserAccounts] = useState([])
  const navigate = useNavigate()
  const [userData, setuserData] = useState([])
  const [selectedAccount, setSelectedAccount] = useState(null);

  const [receiverInput, setReceiverInput] = useState("");
  const [receiverWallets, setReceiverWallets] = useState([]);
  const [selectedWallet, setSelectedWallet] = useState("");
  const [selectedToken, setSelectedToken] = useState("");
  const [amount, setAmount] = useState(0);
  const [recentHistory, setRecentHistory] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [users, setUsers] = useState([]);
  const [receiverType, setReceiverType] = useState('wallet');
  const [tokenBalance, setTokenBalance] = useState(0);

  const [recipientAddress, setRecipientAddress] = useState([]);
  const [selectedRecipient, setSelectedRecipient] = useState();
  const [recipientSearch, setRecipientSearch] = useState("");

  const [ConfirmPay, setConfirmPay] = useState(false);
  const [Select_Recipient, setSelect_Recipient] = useState(false);
  const [isActive, setActive] = useState('div1')
  const [note_popup, setNote_popup] = useState(false);
  const [showLoader, setshowLoader] = useState(false)

  const [recipientName, setRecipientName] = useState("");
  const [recipientWallet, setRecipientWallet] = useState("");


  const handleActivetab = () => {
    setActive((prev) => (prev === 'div1' ? 'div2' : 'div1'));
    setAmount(0);
    setSelectedToken("");
    setReceiverInput("");
    setSelectedRecipient()

  }

  const tokenList = [
    {
      name: "Tether USD",
      symbol: "USDT",
      address: "0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7",
      decimal: 6
    },
    {
      name: "USD Coin",
      symbol: "USDC",
      address: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E",
      decimal: 6
    }
  ];

  const getUserdatas = async () => {
    try {
      setshowLoader(true)
      const token = sessionStorage.getItem('_token');
      if (!token) {
        toast.error('Session Expired');
        setshowLoader(false)
        navigate('/Login');
        return;
      }

      const decodedToken = jwtDecode(token);
      const res = await axios.get(`${SERVER_URL}/api/getUserdatas?AppID=${decodedToken.AppID}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data.status) {

        setuserData(res.data.User);
        setUserAccounts(res.data.accounts)
        const choosedAccount = sessionStorage.getItem('selectedAccount');

        if (!choosedAccount) {
          setSelectedAccount(res.data.accounts.length > 0 ? res.data.accounts[0].wallet_address : null);
          sessionStorage.setItem('selectedAccount', res.data.accounts.length > 0 ? res.data.accounts[0].wallet_address : null)
        } else {
          setSelectedAccount(sessionStorage.getItem('selectedAccount'))
        }
      } else {
        setuserData([]);
        setSelectedAccount(null);
      }
      setshowLoader(false)
    } catch (error) {
      console.error('Error fetching user data:', error);

      if (error.response?.status === 403) {
        toast.error('Session expired');
        navigate('/Login');
      } else {
        toast.error('Something went wrong. Please try again.');
      }
      setshowLoader(false)
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem('_token');
    if (token) {
      getUserdatas();
    }
  }, [sessionStorage.getItem('_token')]);

  useEffect(() => {
    const getAddressess = setTimeout(() => {
      if (receiverInput !== '') {
        getReceiverWallets();
      }
    }, 500);

    return () => clearTimeout(getAddressess);
  }, [receiverInput]);

  const getReceiverWallets = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/api/getReceiverWallets?input=${receiverInput}`);
      if (response.data.status) {
        setReceiverWallets(response.data.accounts);
      } else {
        setReceiverWallets([]);
      }
    } catch (error) {
      console.error("Error fetching receiver wallet:", error);
    }
  };

  const isValidEvmAddress = (address) => {
    return ethers.utils.isAddress(address);
  };

  const checkData = async () => {
    try {
      setshowLoader(true)
      let receiverAddress;
      let receivername;
      let receivedToken;
      let receivedAmount;

      if (receiverType === "wallet") {
        receiverAddress = receiverInput;
        receivername = "wallet-transfer";
        receivedToken = selectedToken?.symbol;
        receivedAmount = amount;
      } else if (receiverType === "user") {
        receiverAddress = selectedRecipient?.wallet_address;
        receivername = selectedRecipient?.app_id;
        receivedToken = selectedToken?.symbol;
        receivedAmount = amount;
      }

      const token = sessionStorage.getItem('_token');
      if (!token) {
        toast.error('Session Expired');
        setshowLoader(false)
        setTimeout(() => {
          navigate('/Login');
        }, 1500);
        return;
      }

      if (receiverType === 'wallet' && !receiverInput) {
        toast.error("Please fill in the wallet address.");
        setshowLoader(false)
        return;
      }
      if (receiverType === 'user' && !selectedRecipient) {
        toast.error("Select the receiver wallet");
        setshowLoader(false)
        return;
      }
      if (receiverType === 'wallet' && receiverInput) {
        let walletVerify = await isValidEvmAddress(receiverInput);
        if (!walletVerify) {
          toast.error("Please enter a valid Address.");
          setshowLoader(false)
          return;
        }
      }
      if (!selectedToken) {
        toast.error("Select the token");
        setshowLoader(false)
        return;
      }
      if (amount <= 0) {
        toast.error("Enter a valid amount");
        setshowLoader(false)
        return;
      }
      if (selectedAccount === receiverAddress) {
        toast.error("Cannot transfer funds to the same wallet address.");
        setshowLoader(false);
        return;
      }
      let totalAmount = Number(amount) / 0.98;
      const tokenSymbol = selectedToken?.symbol;
      const userBalance = await getTokenBalance(selectedAccount, tokenSymbol);
      console.log(`User ${tokenSymbol} Balance:`, userBalance);

      if (userBalance <= 0 || userBalance < totalAmount) {
        toast.error(`Insufficient ${tokenSymbol} balance. Please check your funds.`);
        setshowLoader(false)
        return;
      }
      setshowLoader(false)
      setConfirmPay(true)
    } catch (error) {
      console.error("Data check error : ", error);
      setshowLoader(false)
    }
  }

  const handleTransfer = async () => {
    let toastId;
    const token = sessionStorage.getItem('_token');

    try {

      setshowLoader(true)
      let receiverAddress;
      let receivername;
      let receivedToken;
      let receivedAmount;

      if (receiverType === "wallet") {
        receiverAddress = receiverInput;
        receivername = selectedRecipient?.app_id;
        receivedToken = selectedToken?.symbol;
        receivedAmount = amount;
      } else if (receiverType === "user") {
        receiverAddress = selectedRecipient?.wallet_address;
        receivername = selectedRecipient?.app_id;
        receivedToken = selectedToken?.symbol;
        receivedAmount = amount;
      }
      let totalAmount = Number(amount) / 0.98;
      const transferData = {
        transferType: receiverType,
        from_id: userData.app_id,
        to_id: selectedRecipient?.app_id,//receiverType === 'user' ? selectedRecipient?.app_id : '',
        fromAddress: selectedAccount,
        toAddress: receiverAddress,
        tokenAddress: selectedToken?.address,
        tokenSymbol: selectedToken?.symbol,
        amount: totalAmount.toFixed(6),
      };

      // toastId = toast.loading("Processing transfer...");

      const transferRes = await axios.post(`${SERVER_URL}/api/transaferFunds`, transferData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // toast.dismiss(toastId);

      if (transferRes.data.status === true) {
        setshowLoader(false)
        toast.success("Transfer successful!");
        setConfirmPay(false)
        setTimeout(() => {
          window.location.reload()
        }, 1500);
      } else {
        setshowLoader(false)
        toast.error(transferRes.data.message || "Transfer failed. Please try again.");
      }
    } catch (error) {
      setshowLoader(false)
      // toast.dismiss(toastId);
      console.error("Transfer error:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };


  useEffect(() => {
      if (selectedToken?.symbol !== '') {
        const tokenSymbol = selectedToken?.symbol;
        getTokenBalance(selectedAccount, tokenSymbol);
      }

  }, [selectedToken, selectedAccount]);

  const getTokenBalance = async (walletAddress, tokenSymbol) => {
    try {
      let tokenContract, decimals;

      if (tokenSymbol === "USDT") {
        tokenContract = usdtcontractaddress;
        decimals = 6;
      } else if (tokenSymbol === "USDC") {
        tokenContract = usdccontractaddress;
        decimals = 6;
      } else {
        console.error("Unsupported token:", tokenSymbol);
        return 0;
      }

      const provider = new ethers.providers.JsonRpcProvider(AVALANCHE_RPC);
      const TokenContract = new ethers.Contract(tokenContract, token_abi, provider);

      const balance = await TokenContract.balanceOf(walletAddress);
      setTokenBalance(Number(ethers.utils.formatUnits(balance, decimals)));
      return Number(ethers.utils.formatUnits(balance, decimals));
    } catch (error) {
      console.error(`Error fetching ${tokenSymbol} balance:`, error);
      return 0;
    }
  };

  const [debitedAmount, setDebitedAmount] = useState(0);
  const [creditedAmount, setUserCreditedAmount] = useState(0);

  const getUserTransactions = async (app_id) => {
    try {
      setshowLoader(true)
      const res = await axios.get(`${SERVER_URL}/api/transaction?app_id=${app_id}`);
      if (res.data.status) {
        setRecentHistory(res.data.transactions);
        const transactions = res.data.transactions;
        let totalDebited = 0;
        let totalCredited = 0;

        transactions.forEach((txn) => {
          if (txn.from_id === app_id) {
            totalDebited += Number(txn.amount);
          }
          if (txn.to_id === app_id) {
            totalCredited += Number(txn.amount);
          }
        });

        setDebitedAmount(totalDebited);
        setUserCreditedAmount(totalCredited);
      } else {
        console.error("Error fetching transactions:", res.data.message);
        setshowLoader(false)
      }
      setshowLoader(false)
    } catch (error) {
      console.error("Error fetching transactions:", error);
      setshowLoader(false)

    }
  };

  const filteredTransactions = recentHistory?.filter((data) =>
    data.to_id.toLowerCase().includes(searchQuery.toLowerCase()) ||
    data.to_wallet.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const filteredRecipient = recipientAddress ?? recipientAddress?.filter((data) =>
    data.walletAddress?.toLowerCase().includes(recipientSearch.toLowerCase()) ||
    data.walletName?.toLowerCase().includes(recipientSearch.toLowerCase())
  );

  const fetchUsers = async (app_id) => {
    try {
      const res = await axios.get(`${SERVER_URL}/api/users?app_id=${app_id}`);
      if (res.data.status) {
        setUsers(res.data.users);
      } else {
        console.error("Error:", res.data.message);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    if (userData?.app_id) {
      fetchUsers(userData.app_id);
      getUserTransactions(userData.app_id);
      getRecipients(userData.app_id);
    }
  }, [userData]);

  useEffect(() => {
    setSelectedAccount(sessionStorage.getItem('selectedAccount'))
  }, [sessionStorage.getItem('selectedAccount')]);


  const ViewHash = (hash) => {
    window.open(`https://snowtrace.io/tx/${hash}`, "_blank");
  };

  const handleAddRecipient = async () => {

    if (!userData.app_id || !recipientWallet || !recipientName) {
      toast.error("All fields are required!");
      return;
    }
    let walletVerify = await isValidEvmAddress(recipientWallet);
    if (!walletVerify) {
      toast.error("Please enter a valid Address.");
      return;
    }
    const token = sessionStorage.getItem("_token");
    try {
      const response = await axios.post(`${SERVER_URL}/api/addRecipient`, { app_id: userData.app_id, recipientWallet, recipientName },
        { headers: { Authorization: `Bearer ${token}` }, });

      if (response.data.status === true) {
        toast.success("Recipient added successfully!");
        getRecipients(userData.app_id)
        setRecipientWallet("");
        setRecipientName("");
      } else {
        toast.error(response.data.message || "Failed to add recipient.");
      }
    } catch (error) {
      console.error("Error adding recipient:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };

  const getRecipients = async (app_id) => {
    try {
      const response = await axios.get(`${SERVER_URL}/api/getRecipients?app_id=${app_id}`,
        { headers: { Authorization: `Bearer ${sessionStorage.getItem("_token")}` }, });
      if (response.data.status) {
        setRecipientAddress(response.data.data)
      } else {
        setRecipientAddress([])
      }
    } catch (error) {
      console.error("Error fetching receiver wallet:", error);
    }
  };



  return (
    <div className="w-full bg-[#060606] relative h-screen overflow-hidden overflow-y-auto text-white font-poppins ">
      <div
        className="z-0 absolute -top-36 left-0 right-0 w-[90%] mx-auto h-96 opacity-30 "
        style={{ background: "radial-gradient(50% 50% at 50% 50%, #FFF2C2 0%, rgba(0, 0, 0, 0) 100%)", }}
      ></div>
      <div className=" pb-5 mt-10 flex lg:flex-row flex-col gap-12 sm:gap-0">
        <div className="lg:w-1/2 w-full ">
          <div className="md:px-20 px-5">
            <p className="font-Artemus text-2xl ">SEND</p>
            <hr className=" border border-[#856E4F] w-7 " />
            <p className=" font-light mt-3 text-sm ">
              Choose people to start fast transfers!
            </p>
          </div>

          <div className="mt-7 w-[95%] mx-auto max-w-lg z-30 relative ">
            <div>
              <img
                src="../assets/other/Send1.svg"
                className=" mx-auto -translate-y-12 z-0 "
              />
            </div>
            <div className="z-10 absolute top-0 w-full bg-gradient-to-b from-[#0B0F10]/50 to-[#241D14]/50 rounded-2xl border border-[#2F2F2F] sm:p-10 p-5 ">
              <div className="relative">
                <p className="font-Artemus text-2xl text-center mt-8">
                  {isActive === 'div1' ? "SEND" : "SELECT RECEIPIENT"}
                </p>
                <button className="absolute -top-10 -right-2 bg-white/10 text-white/75 px-3 py-1 rounded-full text-sm" onClick={() => { handleActivetab(); setReceiverType(isActive === 'div2' ? "wallet" : "user") }}>
                  {isActive === 'div1' ? "Add Receipient + " : "< Back"}
                </button>
              </div>

              <div className={` font-montserrat mt-5  ${isActive === 'div1' ? 'block' : 'hidden'}`}>

                <input
                  type="text"
                  className="w-full px-3 py-2 mb-3 text-base bg-black/60 focus:outline-none border border-[#F6FFE91F] rounded-md"
                  placeholder="Enter Wallet Address"
                  value={receiverInput ?? selectedRecipient.wallet_address}
                  onChange={(e) => setReceiverInput(e.target.value)}
                />

                <div className="">
                  <select
                    className="mt-5 text-white/60 text-sm bg-black/60 rounded-md w-full px-3 py-2.5 focus:outline-none border border-[#F6FFE91F]"
                    value={selectedToken?.symbol || ""}
                    onChange={(e) => {
                      const selected = tokenList.find((token) => token.symbol === e.target.value);
                      setSelectedToken(selected || null);
                    }}
                  >
                    <option className="bg-black text-white" value="">Choose Token</option>
                    {tokenList.map((token) => (
                      <option className="bg-black text-white" key={token.symbol} value={token.symbol}>
                        {token.symbol} - {token.name}
                      </option>
                    ))}
                  </select>

                </div>

                <div className=" my-5 flex justify-center ">
                  <FontAwesomeIcon
                    icon={faArrowRightArrowLeft}
                    size="lg"
                    className=" rotate-90 "
                  />
                </div>

                <div>
                  <input
                    type="number"
                    className="bg-black/60 text-white rounded-md w-full px-3 py-2.5 mb-2 focus:outline-none text-sm border border-[#F6FFE91F]"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    placeholder="Enter Amount"
                  />
                  <span> Balance : {" "}
                    {tokenBalance}
                  </span>
                </div>

                <div className="mt-10 ">
                  <div className="bg-gradient-to-br from-[#F6FFE9] to-[#94998C] p-0.5 rounded-full">
                    <div
                      className={`relative ${isSwipedRight
                        ? "bg-green-500"
                        : "bg-gradient-to-r from-[#1A1B18] to-[#856E4F]"
                        } rounded-full p-2 flex justify-center items-center`}>
                      <div
                        onClick={() => { checkData(); setReceiverType("wallet") }}
                        className={`w-[100%] mx-auto absolute left-1 transition-transform duration-500 ${isSwipedRight
                          ? "md:translate-x-[88%] translate-x-[82%]"
                          : "translate-x-0"
                          }`}>
                        <div className={`w-10 h-10 cursor-pointer rounded-full bg-white flex justify-center items-center`}>
                          <FontAwesomeIcon icon={faChevronRight} className="" style={{ color: "#856E4F" }} />
                          <FontAwesomeIcon icon={faChevronRight} className="-translate-x-1" style={{ color: "#856E4F" }} />
                        </div>
                      </div>
                      <div className="w-[90%] mt-1">
                        <p className="font-Artemus text-lg text-center font-medium">
                          Preview
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`font-montserrat mt-5  ${isActive === 'div2' ? 'block' : 'hidden'}`}>
                <div>
                  <div className='bg-black border border-[#F6FFE91F]  rounded-md w-[100%] py-2.5 px-3 text-sm cursor-pointer text-white/60 flex items-center justify-between' onClick={() => setSelect_Recipient(true)}>
                    {selectedRecipient ? selectedRecipient.wallet_address : "Select recipients"}  <FontAwesomeIcon icon={faChevronDown} className="text-xs" />
                  </div>
                </div>

                <p className="font-Artemus text-2xl text-center mt-8">
                  CREATE RECEIPIENT
                </p>

                <div className="relative w-full">
                  <input
                    type="text"
                    className="bg-black/60 mt-5 text-white rounded-md w-full px-3 py-2.5 focus:outline-none text-sm border border-[#F6FFE91F]"
                    placeholder="Enter Receipent Name"
                    value={recipientName}
                    onChange={(e) => setRecipientName(e.target.value)}
                  />
                </div>
                <div>
                  <input
                    type="text"
                    className="bg-black/60 mt-5 text-white rounded-md w-full px-3 py-2.5 focus:outline-none text-sm border border-[#F6FFE91F]"
                    placeholder="Enter Receipent Wallet Address"
                    value={recipientWallet}
                    onChange={(e) => setRecipientWallet(e.target.value)}
                  />
                </div>

                <div className="mt-10 ">
                  <div className="bg-gradient-to-br from-[#F6FFE9] to-[#94998C] p-0.5 rounded-full cursor-pointer "
                    onClick={() => { handleAddRecipient(); }}
                  >
                    <div className="relative bg-gradient-to-r from-[#1A1B18] to-[#856E4F] rounded-full p-2 flex justify-center items-center">
                      <div className="w-[100%] mx-auto absolute left-1"                      >
                      </div>
                      <div className="w-[90%] mt-1">
                        <p className="font-Artemus text-lg text-center font-medium">
                          ADD RECIPIENT
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>

        <div className="lg:w-1/2 w-full md:pr-10 px-3 mt-5 sm:mt-0">

          <div className="  ">
            <div className="z-10 relative bg-gradient-to-b from-[#FFF2C2] to-[#856E4F] rounded-2xl lg:pb-10 pb-5 lg:px-14 px-5">
              <div className=" flex justify-center items-center -translate-y-5 ">
                <div className=" bg-[#0D0E14] rounded-full border border-[#4D4F5C] py-3 px-5 ">
                  <p className=" text-[#CFD3DA] font-Artemus ">
                    Overall transfers
                  </p>
                </div>
              </div>
              <div className=" overflow-hidden ">
                <div className=" w-80 h-72  rounded-full bg-black/10 absolute bottom-16 -right-20 "></div>
                <div className=" w-80 h-72  rounded-full bg-black/10 absolute top-16 -left-20 "></div>

                <div className="flex justify-between text-black ">
                  <div className="flex flex-col items-center gap-3">
                    <p className="sm:text-3xl text-xl font-medium font-Artemus">$ {Number(debitedAmount).toFixed(3)}</p>
                    <p className=" font-semibold font-montserrat "> Received</p>
                  </div>
                  <div className="flex flex-col items-center gap-3">
                    <p className="sm:text-3xl text-xl font-medium font-Artemus">$ {Number(creditedAmount).toFixed(3)}</p>
                    <p className=" font-semibold font-montserrat ">
                      {/* Withdrawals */} Sent
                    </p>
                  </div>
                  <div className="flex flex-col items-center gap-3">
                    <p className="sm:text-3xl text-xl font-medium font-Artemus">$ 0</p>
                    <p className=" font-semibold font-montserrat ">Deposit</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-7 z-30 w-full bg-gradient-to-b from-[#0B0F10]/50 to-[#241D14]/50 rounded-2xl border border-[#2F2F2F] p-5 ">
            <div className="flex items-center gap-2">
              <p className="font-Artemus text-xl uppercase mt-1 z-30">
                Recent History
              </p>
              <FontAwesomeIcon icon={faClockRotateLeft} />
            </div>

            <div className="relative z-30 mt-3">
              <input
                className="w-full focus:outline-none text-sm font-medium bg-transparent rounded-full border border-white/15 pl-10 pr-3 py-2 placeholder:text-white/50"
                placeholder="search receiver App ID or wallet Address" value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <span className="absolute top-2 left-3">
                <FontAwesomeIcon
                  icon={faMagnifyingGlass}
                  className="text-white/30"
                />
              </span>
            </div>

            <div className="mt-5">
              {filteredTransactions.length > 0 ? (
                filteredTransactions?.slice(0, 5)?.map((data, index) => (
                  <div key={index} className="bg-[#D9D9D90D] mt-3 rounded-2xl py-3 px-5 flex justify-between gap-5 items-center ">
                    <div className="flex items-center gap-2">
                      <img src='../assets/Profile/Sendprofile5.svg' />
                      <div>
                        <p>{data.to_id}</p>
                        <p className=" text-xs md:text-sm  font-light">{data.created_at}</p>
                      </div>
                    </div>

                    <div className="flex items-center gap-3">
                      <p className=" text-sm">{data.amount} {data.token_name}</p>
                      <FontAwesomeIcon icon={faChevronRight} onClick={() => ViewHash(data.trn_hash)} className="cursor-pointer" />
                    </div>
                  </div>
                ))) : (
                <p className="text-center text-gray-500">No transactions found.</p>
              )}
            </div>
          </div>

        </div>
      </div>

      {ConfirmPay && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/75 z-50 fade-in" >
          <div className="w-[90%] md:w-[50%] lg:w-[33%] 2xl:w-[30%] bg-[#252728] border border-[#FFF2C25E] rounded-xl">
            <div className="flex justify-end pt-2 px-2">
              <button onClick={() => setConfirmPay(false)} className="text-white">
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </div>
            <div className="text-white text-center pb-7">
              <h2 className="text-2xl font-semibold font-Artemus px-5 md:px-7 2xl:px-10"> Confirm </h2>
              <div className="text-left border-y border-white/20 px-5 md:px-7 2xl:px-10 py-2">
                <label className="text-white/50">From</label>
                <p className="truncate mt-1">{selectedAccount}</p>
              </div>
              <div className="text-left border-b border-white/20 px-5 md:px-7 2xl:px-10 py-2">
                <label className="text-white/50">To</label>
                <p className="truncate mt-1">{receiverType === 'wallet' ? receiverInput : selectedRecipient?.wallet_address}</p>
              </div>
              {/* <div className="text-left border-b border-white/20 flex justify-between items-center px-5 md:px-7 2xl:px-10 py-5">
                <label className="">Network fee</label>
                <p>0.001 AVAX</p>
              </div> */}
              <div className="border border-white/20 rounded-md w-[80%] mx-auto px-5 py-2 flex justify-between items-center mt-3">
                <label className="font-medium">Max total</label>
                <p className="font-bold">$ {amount ? (Number(amount) / 0.98).toFixed(6) : 0}</p>
              </div>
              <button className='mt-5 bg-white w-[40%] rounded-full py-2 font-Artemus font-semibold text-black' onClick={handleTransfer}>SEND</button>
            </div>
          </div>
        </div>
      )}

      {Select_Recipient && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/75 z-50 fade-in" >
          <div className="w-[90%] md:w-[50%] lg:w-[33%] 2xl:w-[30%] bg-[#252728] border border-[#FFF2C25E] rounded-xl">
            <div className="flex justify-end pt-2 px-2">
              <button onClick={() => setSelect_Recipient(false)} className="text-white">
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </div>
            <div className="text-white text-center pb-7 px-5 md:px-7 2xl:px-10">
              <h2 className="text-2xl font-semibold font-Artemus ">Select recipient</h2>
              <div className="flex items-center gap-2 border border-white/20 rounded-full mt-3">
                <FontAwesomeIcon icon={faMagnifyingGlass} className="ml-3 text-white/50" />
                <input className="bg-transparent outline-none py-2 px-3 w-full" onChange={(e) => { setRecipientSearch(e.target.value) }} placeholder="Search"></input>
              </div>
              <div className="mt-3 space-y-3 max-h-64 overflow-y-auto" style={{ scrollbarColor: 'white transparent', scrollbarWidth: 'thin' }}>
                {filteredRecipient && filteredRecipient.length > 0 ? (
                  filteredRecipient.map((item, index) => (
                    <div key={index} onClick={() => { setSelectedRecipient(item); setReceiverInput(item.walletAddress); setSelect_Recipient(false); setActive('div1') }} className="bg-[#D9D9D90D] cursor-pointer rounded-lg px-5 py-3 flex items-center gap-4 mr-1">
                      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQV21qbrXc1O72skqmdIYO6RhpKwmFaISgDcj3SuhNPDa8jdm503_7gSfEwDXnMTW1mmxU&usqp=CAU" className="w-14 h-14 rounded-full"></img>
                      <div className="text-left">
                        <h1 className="text-sm font-medium">{item.walletName}</h1>
                        <h2 className="text-white/70 text-xs truncate 2xl:text-base">
                          {item.walletAddress.slice(0, 10)}......{item.walletAddress.slice(-10)}
                        </h2>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center text-white/70 text-sm mt-2">No wallet address found</div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {note_popup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/75 z-50 fade-in" >
          <div className="w-[90%] md:w-[50%] lg:w-[37.5%] bg-[#252728] border border-[#FFF2C25E] rounded-xl">
            <div className="flex justify-end pt-2 px-2">
              <button onClick={() => setNote_popup(false)} className="text-white">
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </div>
            <div className="text-white text-center px-5 md:px-7 2xl:px-10 pb-7">
              <h2 className="text-2xl font-semibold font-Artemus "> Note </h2>
              <p className='mt-3 text-sm leading-6 font-normal text-justify'><span className='font-bold'>Users</span> are responsible for verifying counterparties and ensuring secure transaction.</p>
              <button className='mt-5 bg-white w-[70%] rounded-full py-2 font-Artemus font-semibold text-black' onClick={() => setNote_popup(false)}>OK</button>
            </div>
          </div>
        </div>
      )}

      {showLoader && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999, // Ensures overlay appears on top
            backdropFilter: "blur(5px)", // Apply blur effect to background
          }}
        >
          <div className="flex flex-col gap-4 justify-center items-center">
            <ClipLoader color="#ffffff" size={50} />
            <p style={{ color: "#ffffff", fontSize: "18px" }} className="text-center">
              Loading...
            </p>
          </div>

        </div>
      )}
    </div>
  );
};

export default Send;
